import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Login',
	component: () => import('../views/login.vue'),
	meta: {
		title: '登录',
		keepAlive: false,
		noHead: true
	}
}, {
	path: '/school',
	name: 'School',
	component: () => import('../views/school.vue'),
	meta: {
		title: '学校管理',
		keepAlive: false
	}
}, {
	path: '/studentcp',
	name: 'Studentcp',
	component: () => import('../views/studentcp.vue'),
	meta: {
		title: '企微学生',
		keepAlive: false
	}
}, {
	path: '/studenthik',
	name: 'Studenthik',
	component: () => import('../views/studenthik.vue'),
	meta: {
		title: '海康学生',
		keepAlive: false
	}
}, {
	path: '/log',
	name: 'Log',
	component: () => import('../views/log.vue'),
	meta: {
		title: '推送日志',
		keepAlive: false
	}
}, {
	path: '/authorization',
	name: 'Authorization',
	component: () => import('../views/authorization.vue'),
	meta: {
		title: '学生授权',
		keepAlive: false
	}
}, {
	path: '/order',
	name: 'Order',
	component: () => import('../views/order.vue'),
	meta: {
		title: '订单管理',
		keepAlive: false
	}
}, {
	path: '/user',
	name: 'User',
	component: () => import('../views/user.vue'),
	meta: {
		title: '用户管理',
		keepAlive: false
	}
}, {
	path: '/project',
	name: 'Project',
	component: () => import('../views/project.vue'),
	meta: {
		title: '项目列表',
		keepAlive: false
	}
}, {
	path: '/schoolList',
	name: 'SchoolList',
	component: () => import('../views/schoolList.vue'),
	meta: {
		title: '学校列表',
		keepAlive: false,
		noHead: true
	}
}]

const router = new VueRouter({
	routes
})

export default router
